export default {"src":"/_next/static/media/es-flag.aaf3e025.svg","height":18,"width":26,"blurWidth":0,"blurHeight":0};